import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

type PostLoginBody = {
  email: string;
  password: string;
};
type queryUser = {
  page: number;
  search: string;
};
export const classApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllClass: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        classStatus?: number;
        isDelete?: boolean;
        tutorId?: string;
      }
    >({
      query: ({ page, search, classStatus, isDelete, tutorId }) => {
        let url = `${END_POINTS.getAllClass}?page=${page}&${
          isDelete ? `isDelete=true` : `status=${classStatus}`
        }&search=${search}${tutorId ? `&tutorId=${tutorId}` : ""}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getClassDetails: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
        tutorId: string;
      }
    >({
      query: ({ page, search, tutorId }) => {
        let url = `${END_POINTS.classDetails}?page=${page}&tutorId=${tutorId}&search=${search}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    getClassById: builder.query<
      CommonResponseType & { data: any },
      { classId: any }
    >({
      query: ({ classId }) => ({
        url: `${END_POINTS.getClassById}/${classId}/`,
        method: "GET",
      }),
    }),

    getTutorList: builder.query<CommonResponseType & { data: any }, void>({
      query: () => ({
        url: `${END_POINTS.getTutorList}`,
        method: "GET",
      }),
    }),

    getSubjectList: builder.query<
      CommonResponseType & { data: any },
      { tutorId: string }
    >({
      query: ({ tutorId }) => ({
        url: `${END_POINTS.getSubjectList}?tutorId=${tutorId}`,
        method: "GET",
      }),
    }),

    addClass: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addClass}`,
        method: "POST",
        body,
      }),
    }),
    updateClass: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateClass}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteByIdClass: builder.query<
      CommonResponseType & { data: any },
      { classId: any }
    >({
      query: ({ classId }) => ({
        url: `${END_POINTS.deleteByIdclass}/${classId}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetTutorListQuery,
  useLazyGetSubjectListQuery,
  useLazyGetAllClassQuery,
  useLazyGetClassByIdQuery,
  useLazyDeleteByIdClassQuery,
  useAddClassMutation,
  useUpdateClassMutation,
  useLazyGetClassDetailsQuery,
} = classApi;
